import { EquisColors, EquisUtilsModule } from '@tn-equis/core/utils';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

var EquisAvatarSize;
(function (EquisAvatarSize) {
    EquisAvatarSize["SMALL"] = "small";
    EquisAvatarSize["MEDIUM"] = "medium";
    EquisAvatarSize["LARGE"] = "large";
    EquisAvatarSize["EXTRA_LARGE"] = "extra-large";
    EquisAvatarSize["EXTRA_EXTRA_LARGE"] = "extra-extra-large";
})(EquisAvatarSize || (EquisAvatarSize = {}));
var EquisAvatarType;
(function (EquisAvatarType) {
    EquisAvatarType["LETTER"] = "letter";
    EquisAvatarType["IMAGE"] = "image";
    EquisAvatarType["DRAW"] = "draw";
})(EquisAvatarType || (EquisAvatarType = {}));
var EquisAvatarDrawType;
(function (EquisAvatarDrawType) {
    EquisAvatarDrawType["RATON"] = "raton";
    EquisAvatarDrawType["PALOMA"] = "paloma";
    EquisAvatarDrawType["TIBURON"] = "tiburon";
    EquisAvatarDrawType["GATO"] = "gato";
    EquisAvatarDrawType["PERRO"] = "perro";
    EquisAvatarDrawType["NEGOCIO"] = "negocio";
})(EquisAvatarDrawType || (EquisAvatarDrawType = {}));
const EquisAvatarPath = {
    raton: './assets/images/avatars/raton.svg',
    paloma: './assets/images/avatars/paloma.svg',
    tiburon: './assets/images/avatars/tiburon.svg',
    gato: './assets/images/avatars/gato.svg',
    perro: './assets/images/avatars/perro.svg',
    negocio: './assets/images/avatars/negocio.svg',
};

class EquisAvatarComponent {
    constructor() {
        this._size = EquisAvatarSize.MEDIUM;
        this._type = EquisAvatarType.LETTER;
        this.avatarType = EquisAvatarType;
        this.backgroundColor = EquisColors.Blue_300;
        this.avatarEvents = new EventEmitter();
    }
    set draw(draw) {
        this.imageURL = EquisAvatarPath[draw];
    }
    set letter(letter) {
        this._letter = letter && letter.substring(0, 2).toUpperCase();
    }
    set type(type) {
        this._type = Object.values(EquisAvatarType).includes(type)
            ? type
            : EquisAvatarType.LETTER;
    }
    set size(size) {
        this._size = Object.values(EquisAvatarSize).includes(size)
            ? size
            : EquisAvatarSize.MEDIUM;
    }
    onClick() {
        this.avatarEvents.emit(true);
    }
}
EquisAvatarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisAvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisAvatarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisAvatarComponent, selector: "z-avatar, equis-avatar", inputs: { imageURL: "imageURL", clickable: "clickable", letterColor: "letterColor", backgroundColor: "backgroundColor", draw: "draw", letter: "letter", type: "type", size: "size" }, outputs: { avatarEvents: "avatarEvents" }, ngImport: i0, template: "<div\n  class=\"avatar\"\n  [ngStyle]=\"{ 'background-color': backgroundColor }\"\n  [ngClass]=\"['avatar--' + _size, clickable ? 'avatar--clickable' : '']\"\n  (click)=\"onClick()\"\n>\n  <p\n    *ngIf=\"_type === avatarType.LETTER\"\n    class=\"avatar__letter\"\n    [ngClass]=\"[letterColor ? 'avatar__letter--font-color' : '']\"\n  >\n    {{ _letter }}\n  </p>\n  <img\n    *ngIf=\"_type === avatarType.IMAGE || _type === avatarType.DRAW\"\n    class=\"avatar__image\"\n    [src]=\"imageURL\"\n    alt=\"Avatar image\"\n  />\n</div>\n", styles: [".avatar{border:1px solid #e8e8e8;border-radius:8px;overflow:hidden}.avatar__letter{align-items:center;color:#fff;display:flex;font-family:Gibson-Medium,sans-serif;font-weight:700;height:100%;justify-content:center}.avatar__letter--font-color{background:#f3eef6;color:#50007f}.avatar__image{height:100%;width:auto}.avatar--small{font-size:16px;height:23px;line-height:24px;width:23px}.avatar--medium{border:0;border-radius:8px;font-size:14px;height:32px;line-height:16px;width:32px}.avatar--large{border:0;border-radius:12px;font-size:18px;height:40px;line-height:22px;width:40px}.avatar--extra-large{border:0;border-radius:16px;font-size:20px;height:48px;line-height:24px;width:48px}.avatar--extra-extra-large{border:0;border-radius:12px;font-size:20px;height:56px;line-height:24px;width:56px}.avatar--clickable{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisAvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-avatar, equis-avatar', template: "<div\n  class=\"avatar\"\n  [ngStyle]=\"{ 'background-color': backgroundColor }\"\n  [ngClass]=\"['avatar--' + _size, clickable ? 'avatar--clickable' : '']\"\n  (click)=\"onClick()\"\n>\n  <p\n    *ngIf=\"_type === avatarType.LETTER\"\n    class=\"avatar__letter\"\n    [ngClass]=\"[letterColor ? 'avatar__letter--font-color' : '']\"\n  >\n    {{ _letter }}\n  </p>\n  <img\n    *ngIf=\"_type === avatarType.IMAGE || _type === avatarType.DRAW\"\n    class=\"avatar__image\"\n    [src]=\"imageURL\"\n    alt=\"Avatar image\"\n  />\n</div>\n", styles: [".avatar{border:1px solid #e8e8e8;border-radius:8px;overflow:hidden}.avatar__letter{align-items:center;color:#fff;display:flex;font-family:Gibson-Medium,sans-serif;font-weight:700;height:100%;justify-content:center}.avatar__letter--font-color{background:#f3eef6;color:#50007f}.avatar__image{height:100%;width:auto}.avatar--small{font-size:16px;height:23px;line-height:24px;width:23px}.avatar--medium{border:0;border-radius:8px;font-size:14px;height:32px;line-height:16px;width:32px}.avatar--large{border:0;border-radius:12px;font-size:18px;height:40px;line-height:22px;width:40px}.avatar--extra-large{border:0;border-radius:16px;font-size:20px;height:48px;line-height:24px;width:48px}.avatar--extra-extra-large{border:0;border-radius:12px;font-size:20px;height:56px;line-height:24px;width:56px}.avatar--clickable{cursor:pointer}\n"] }]
        }], propDecorators: { imageURL: [{
                type: Input
            }], clickable: [{
                type: Input
            }], letterColor: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }], draw: [{
                type: Input
            }], letter: [{
                type: Input
            }], type: [{
                type: Input
            }], size: [{
                type: Input
            }], avatarEvents: [{
                type: Output
            }] } });

class EquisAvatarModule {
    static forRoot() {
        return {
            ngModule: EquisAvatarModule,
        };
    }
}
EquisAvatarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisAvatarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisAvatarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisAvatarModule, declarations: [EquisAvatarComponent], imports: [CommonModule, EquisUtilsModule], exports: [EquisAvatarComponent] });
EquisAvatarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisAvatarModule, imports: [CommonModule, EquisUtilsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisAvatarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisAvatarComponent],
                    imports: [CommonModule, EquisUtilsModule],
                    exports: [EquisAvatarComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EquisAvatarComponent, EquisAvatarDrawType, EquisAvatarModule, EquisAvatarPath, EquisAvatarSize, EquisAvatarType };
